import * as t from 'io-ts';
import type { TypeOf } from 'io-ts';
import optional from '../../../../io-ts/optional';
import { isDefined } from '../../../../typeAssertions/undefined';

export const EvaluationPropsC = t.type({
    maxPoints: optional(t.number),
});

export const RawEvaluationFieldC = t.partial({
    attr: t.partial({
        'data-total-value': t.union([t.string, t.number]),
    }),
});

export type RawEvaluationField = TypeOf<typeof RawEvaluationFieldC>
export type EvaluationProps = TypeOf<typeof EvaluationPropsC>

export default (field: RawEvaluationField): EvaluationProps => {
    const rawMaxPoints = field.attr?.['data-total-value']?.toString();
    const maxPoints = isDefined(rawMaxPoints) ? parseInt(rawMaxPoints, 10) : 0;

    return { maxPoints };
};
